<!-- eslint-disable max-lines -->
<!-- 收入概览 -->
<template>
    <div class="page org-income">
        <div class="page-content">
            <!-- 条件筛选 -->

            <box :showheader="false" class="box-custom search-box">
                <div class="page-content-top">
                    <searchList :searchListConfig="searchListConfig" :roleCodes="roleCodes" :currentRole="currentRole"
                        :currentUserName="currentUserName" @resetCurrent="resetCurrent"
                        :searchOptionsList="searchOptionsList" @search-handle="searchHandle"
                        :searchInitData="searchInitData" />
                    <update-time @reset-current="resetCurrent" :updateTimeBigdataList="updateTimeBigdataList" />
                </div>
            </box>
            <!-- 客户满意度及工单 -->
            <div class="customer-content mt10">
                <customer-complaint class="content-right" :currentRole="currentRole" :config="customerConfig.satisfactionOrder" :customerData="satisfactionOrderData"
                :showMoreLink="false" />
            </div>

            <!-- 客户满意度 -->
            <box title="客户满意度" class="mt10 box-custom" v-loading="satisfactionLoading" :showHeaderUnit="false">
                <el-radio-group class="search-radio" v-model="satisfactionRadioValue" size="mini">
                    <el-radio-button v-for="item in satisfactionType.radioGroup" :key="item.value" :label="item.value">{{
                        item.label }}</el-radio-button>
                </el-radio-group>
                <table-item ref="satisfactionTableRef" :nededFormatValue="false"
                    :version="computedSatisfactionRadioValue"
                    :beforeRequest="satisfactionRequestConfig.beforeRequest"
                    class="overview-table" :afterRequest="satisfactionRequestConfig.afterRequest"
                    :height="satisfactionColumnConfig.height" :columns="calcSatisfactionColumn.columns"
                    :params="satisfactionParams">
                    <template v-slot:col-append="{ col, row }">
                    </template>
                </table-item>
            </box>

            <!-- 工单 -->
            <box title="工单" class="box-custom" v-loading="orderLoading" :showHeaderUnit="false">
                <el-radio-group class="search-radio" v-model="orderRadioValue" size="mini">
                    <el-radio-button v-for="item in customerOrderType.radioGroup" :key="item.value" :label="item.value">{{
                        item.label }}</el-radio-button>
                </el-radio-group>
                <table-item
                    :nededFormatValue="false"
                    :version="computedOrderRadioValue"
                    :show-pagination="true" ref="orderTableRef"
                    :beforeRequest="orderRequestConfig.beforeRequest"
                    :height="orderColumnsConfig.height"
                    :columns="calcOrderColumn.columns"
                    :params="customerOrderAngleParams">
                    <template v-slot:col-append="{ col, row }">
                        <span v-if="col.prop === 'incomeFeeM2M'"
                            :class="getColorValue(row.incomeFeeM2M).className">{{
                                row.incomeFeeM2M }}</span>
                        <span v-else-if="col.prop === 'incomeFeeY2Y'"
                            :class="getColorValue(row.incomeFeeY2Y).className">{{
                                row.incomeFeeY2Y }}</span>
                    </template>
                </table-item>
            </box>
        </div>
    </div>
</template>
<script>
import { ref, onMounted, computed, watch, getCurrentInstance, onActivated } from '@vue/composition-api';
import searchList from '@/views/index/searchList/Index.vue';
import { getUserRoleList, queryUserDataAuth, getCustomerSatisfactionOrder } from '@/api/homePageApi';
import store from '@/store';
import updateTime from '@/views/components/UpdateTime.vue';
import box from '@/views/components/Box.vue';
import {
    satisfactionColumnConfig, orderColumnsConfig, searchListConfig,
    updateTimeBigdataList
} from './column.config.js';
import { whileList, custoemrComplaintConfig } from '../../../index/config.js';
import _ from 'lodash';
import tableItem from '@/views/subPage/component/TableItem.vue';
import homeBgPic from '@/assets/images/homeBg.png';
import { getCustomerOrderAngle, getCustomerSatisfactionAngle } from '@/api/subPageApi.js';
import { getSession } from '@/components/utils/storage';
import customerComplaint from '@/views/index/customerComplaint/Index.vue';
export default {
    components: {
        searchList,
        updateTime,
        box,
        tableItem,
        customerComplaint
    },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const { userCode } = store.getters.user;
        const satisfactionTableRef = ref(null);
        const orderTableRef = ref(null);
        const currentRole = ref({});
        const currentUserName = ref('');
        const roleCodes = ref([]);
        const searchOptionsList = ref({});
        // 顶部筛选条件
        const searchData = ref({});

        // 外部客户达成率统计表况
        const satisfactionRadioValue = ref(`行业`);
        const satisfactionType = ref({
            radioValue: `行业`,
            radioGroup: [{
                value: `行业`,
                label: '行业'
            }, {
                value: '分公司',
                label: '分公司'
            }, {
                value: '客户系',
                label: '客户系'
            }, {
                value: '客户',
                label: '客户'
            }]
        });
        const orderRadioValue = ref(`行业`);
        const customerOrderType = ref({
            radioValue: `行业`,
            radioGroup: [{
                value: `行业`,
                label: '行业'
            }, {
                value: '分公司',
                label: '分公司'
            }, {
                value: '客户系',
                label: '客户系'
            }, {
                value: '客户',
                label: '客户'
            }]
        });

        const getPersonalParams = () => {
            const param = _.pick(currentRole.value, ['roleName', 'roleCode']);
            param.roleType = currentRole.value.dataType;
            return param;
        };
        // 临时方案 0205删除
        const changeCustomerLevel = (customerlevelName) => {
            if (customerlevelName === 'CKA') {
                customerlevelName = '行业CKA';
            }
            return customerlevelName;
        };
        // 公用参数
        const getParams = computed(() => {
            return {
                refresh: true,
                transactionClassCode: `'2'`, // 默认外部
                serviceProductCode: `'all'`,
                organizationCode: `'all'`,
                industryTypeCode: `'all'`,
                userCode: userCode, // 测试账号
                dataType: isYear.value ? 'Y' : 'M',
                dataTime: isYear.value ? searchData.value.yearTime : searchData.value.monthTime,
                // customerlevelName: searchData.value.customerlevelName, // 临时方案 0205恢复
                customerlevelName: changeCustomerLevel(searchData.value.customerlevelName), //  临时方案 0205删除
                ebcdCode: searchData.value.ebcdCode,
                typeId: searchData.value.typeId,
                areaCode: searchData.value.areaCode,
                subBranchCode: searchData.value.subBranchCode,
                businessSceneBigCategory: searchData.value.businessSceneBigCategory
            };
        });

        // 满意度列表查询
        const satisfactionParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'businessSceneBigCategory',
                    'dataTime',
                    'dataType',
                    'refresh',
                    'userCode',
                    'serviceProductCode',
                    'transactionClassCode',
                    'organizationCode'
                ]),
                customerLevelName: getParams.value.customerlevelName,
                angleType: satisfactionRadioValue.value,
                angleCode: 'heji',
                // getApiKey: getApiKey.value,
                api: getCustomerSatisfactionAngle,
                ...getPersonalParams()
            };
        });

        // 工单
        const customerOrderAngleParams = computed(() => {
            return {
                ..._.pick(getParams.value, [
                    'refresh',
                    'dataType',
                    'dataTime',
                    'userCode',
                    'ebcdCode',
                    'businessSceneBigCategory',
                    'transactionClassCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'serviceProductCode',
                    'organizationCode'
                ]),
                customerLevelName: getParams.value.customerlevelName,
                businessType: 'all',
                // transactionClassCode: `'all'`,
                angleType: orderRadioValue.value,
                // TODO: CRM经营中心是否需要angleCode这个入参
                angleCode: 'heji',
                // getApiKey: getApiKey.value,
                api: getCustomerOrderAngle,
                ...getPersonalParams()
            };
        });

        const isYear = computed(() => {
            return searchData.value?.timeStatus === 'year';
        });

        // 表格loading状态统一管理
        const getTableLoading = (tableRef) => computed(() => tableRef.value?.tableListInstance?.tableLoading);
        // 满意度loading
        const satisfactionLoading = getTableLoading(satisfactionTableRef);
        // 工单loading
        const orderLoading = getTableLoading(orderTableRef);

        // 满意度列表请求配置
        const satisfactionRequestConfig = {
            beforeRequest: (condition) => {
                return satisfactionParams.value;
            }
        };

        // 工单请求配置
        const orderRequestConfig = {
            beforeRequest: (condition) => {
                return customerOrderAngleParams.value;
            }
        };

        const customerColumn = ref(satisfactionColumnConfig);
        const orderColumn = ref(orderColumnsConfig);
        const radioColumn = {
            '行业': 'industryColumns',
            '分公司': 'companyColumns',
            '客户系': 'seriesColumns',
            '客户': 'customerColumns'
        };
        // 满意度表格字段
        const calcSatisfactionColumn = computed(() => {
            return {
                columns: customerColumn.value[radioColumn[satisfactionRadioValue.value]]
            };
        });

        // 工单表格字段
        const calcOrderColumn = computed(() => {
            const columns = _.cloneDeep(orderColumn.value[radioColumn[orderRadioValue.value]]);
            columns.forEach(it => {
                if (it.prop === 'customerMonthPct') {
                    it.label = (isYear.value ? '当年' : '当月') + '外部客户投诉率';
                }
            });
            return {
                columns
            };
        });
        // 动态切换列的时候用传入version进行列的key区分
        const computedSatisfactionRadioValue = computed(() => {
            return satisfactionRadioValue.value + getParams.value.dataTime;
        });
        // 动态切换列的时候用传入version进行列的key区分
        const computedOrderRadioValue = computed(() => {
            return orderRadioValue.value + getParams.value.dataTime;
        });
        const setStrFormat = (val) => {
            if (!Array.isArray(val)) return val;
            return val?.map(item => `'${item}'`).join(',') || '';
        };

        const setCommaStrFormat = (val) => {
            let str = '';
            for (let i = 0; i < val.length; i++) {
                if (val[i].indexOf(',') >= 0) {
                    const arr = val[i].split(',');
                    for (let j = 0; j < arr.length; j++) {
                        str += "'" + arr[j] + "',";
                    }
                } else {
                    str += "'" + val[i] + "',";
                }
            }
            return str.substring(0, str.length - 1); // 删除最后的逗号
        };

        // 筛选赋值
        const searchHandle = (val) => {
            searchData.value = _.cloneDeep(val);
            if (val.industryCategory?.length) {
                searchData.value.typeId = val.industryCategory.map(it => it[0]);
            } else {
                searchData.value.typeId = [];
            }

            searchData.value.ebcdCode = setCommaStrFormat(searchData.value.ebcdCode) || "'all'"; // 专业公司编码
            searchData.value.typeId = setStrFormat(searchData.value.typeId) || "'all'"; // 行业大类
            searchData.value.areaCode = setStrFormat(searchData.value.areaCode) || "'all'"; // 片区
            searchData.value.subBranchCode = setStrFormat(searchData.value.subBranchCode) || "'all'"; // 分公司
            searchData.value.businessSceneBigCategory = setStrFormat(searchData.value.businessSceneBigCategory) || "'all'"; // 业务场景
            getAllData();
        };

        // 获取页面所有数据
        const getAllData = () => {
            Promise.all([getCustomerComplaintInfo()]);
        };
        const getApiKey = ref(1);
        const resetCurrent = () => {
            getApiKey.value++;
            getAllData(true);
        };
        const currentUserMip = ref('');
        // 获取用户角色list
        const getUserRoleInfo = () => {
            if (currentRole.value.dataType && store.getters.homePageParams?.dataType === 'personal') return;
            const currentRoleHome = getSession('currentRoleHome');
            if (store.getters.homePageParams?.dataType || currentRoleHome?.dataType) {
                const _currentRole = _.pick(store.getters.homePageParams, [
                    'roleCode',
                    'roleName',
                    'dataType',
                    'sortNo'
                ]);
                currentRole.value = _currentRole.dataType ? _currentRole : currentRoleHome;
                return;
            }
            const params = { userCode: userCode };
            if (currentRole.value) {
                params.userRoleDataType = currentRole.value.dataType;
            }

            return getUserRoleList(params).then(res => {
                if (res && +res.code === 0) {
                    currentUserMip.value = res.data.userCode;
                    currentUserName.value = res.data.userName;
                    roleCodes.value = res.data.roleCodes;
                    if (Array.isArray(roleCodes.value) && roleCodes.value?.length) {
                        currentRole.value = roleCodes.value[0];
                    }
                    if (currentRole.value.dataType === 'personal') {
                        // customerStatusList.value = statusList.customerList.filter(it => it.role.includes(String(currentRole.value.dataType)));
                        // _opportunityConfig.value = statusList.opportunityList.filter(it => it.role.includes(String(currentRole.value.dataType)));
                    } else {
                        // customerStatusList.value = statusList.customerList.filter(it => it.role.includes('organization'));
                        // _opportunityConfig.value = statusList.opportunityList.filter(it => it.role.includes('organization'));
                    }
                    // customerActive.value = customerStatusList.value[0].type;
                } else {
                    // resetLoading.value = false;
                }
            }).catch(() => {
                // resetLoading.value = false;
            }).finally(() => {
                // homePageShow.value = true;
            });
        };
        const ctx = getCurrentInstance();
        const searchInitData = ref({});
        const getUserDataInfo = () => {
            // searchInitData.value = {};
            const params = {
                ...currentRole.value,
                roleType: currentRole.value.dataType
            };
            return queryUserDataAuth(params).then(res => {
                if (res && +res.code === 0) {
                    currentUserMip.value = res.data.userCode;
                    currentUserName.value = res.data.userName;
                    searchOptionsList.value = res.data;
                    searchInitData.value = store.getters.homePageParams;
                }
            });
        };

        const customerConfig = computed(() => {
            const { satisfactionOrder, complaintOrg, complaintPersonal } = custoemrComplaintConfig;
            return {
                complaint: currentRole.value.dataType === 'personal' ? complaintPersonal : complaintOrg,
                satisfactionOrder: satisfactionOrder
            };
        });
        // 格式化数据- -
        const setCustomerFormatData = (data, initData) => {
            const _data = {};
            for (const item in initData) {
                if (initData.hasOwnProperty(item)) {
                    _data[item] = _.get(data, item, '-');
                }
            }
            return _data;
        };
        const initSatisfactionOrderData = {
            satisfiedPct: '-',
            efftivePct: '-',
            sumCnt: '-',
            sumInTimePct: '-',
            complaintsCnt: '-',
            abnormalCnt: '-'
        };
        const satisfactionOrderData = ref(_.cloneDeep(initSatisfactionOrderData));
        const getCustomerComplaintInfo = () => {
            const params = {
                ..._.pick(getParams.value, [
                    'refresh',
                    'transactionClassCode',
                    'businessSceneBigCategory',
                    'serviceProductCode',
                    'organizationCode',
                    'userCode',
                    'dataTime',
                    'customerlevelName',
                    'ebcdCode',
                    'typeId',
                    'areaCode',
                    'subBranchCode',
                    'dataType'
                ]),
                customerLevelName: getParams.value.customerlevelName,
                ...getPersonalParams()
            };
            getCustomerSatisfactionOrder(params).then(res => {
                if (res && +res.code === 0) {
                    satisfactionOrderData.value = setCustomerFormatData(res.data, initSatisfactionOrderData);
                } else {
                    satisfactionOrderData.value = setCustomerFormatData({}, initSatisfactionOrderData);
                }
            }).catch(() => {
                satisfactionOrderData.value = setCustomerFormatData({}, initSatisfactionOrderData);
            });
        };

        onMounted(async () => {
            document.querySelector('.el-main').style['background']
                = `linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1)),url(${homeBgPic}) center / 100% 100% no-repeat`;
        });
        onActivated(async () => {
            await getUserRoleInfo();
            await getUserDataInfo();
        });

        watch(
            () => ctx.$route,
            (newVal) => {
                if (!whileList.includes(newVal.name) && document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['background'] = '#f3f4f6';
                } else if (document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['background']
                        = `linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1)),url(${homeBgPic}) center / 100% 100% no-repeat`;
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            searchHandle,
            resetCurrent,
            currentRole,
            currentUserName,
            roleCodes,
            searchOptionsList,
            satisfactionColumnConfig,
            orderColumnsConfig,
            satisfactionType,
            customerOrderType,
            orderRadioValue,
            searchData,
            satisfactionParams,
            customerOrderAngleParams,
            isYear,
            searchInitData,
            satisfactionRequestConfig,
            orderRequestConfig,
            satisfactionTableRef,
            orderTableRef,
            satisfactionRadioValue,
            searchListConfig,
            getParams,
            updateTimeBigdataList,
            calcSatisfactionColumn,
            calcOrderColumn,
            currentUserMip,
            satisfactionLoading,
            orderLoading,
            customerConfig,
            satisfactionOrderData,
            computedSatisfactionRadioValue,
            computedOrderRadioValue
        };
    }
};
</script>
<style scoped lang="less">
.page {
    min-width: 1500px;
    width: 100%;

    &-content {
        width: 100%;
        padding: 0 0 10px 0;

        // 按钮组
        .search-radio {
            margin-bottom: 10px;

            // 深度选择
            /deep/ .el-radio-button__inner {
                padding: 5px 15px;
            }

            /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                color: #2881FF;
                border-color: #2881FF;
                background-color: #E5F0FE;
            }

            /deep/ .el-radio-button:first-child:last-child .el-radio-button__inner {
                border-radius: 0px 2px 2px 0px !important;
            }
        }

        .search-box {
            position: sticky;
            top: 0;
            z-index: 100;
            backdrop-filter: blur(25px);
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.9) 100%);
            box-shadow: 0 2px 8px rgba(136, 136, 136, 0.1);
        }

        .box-custom {
            margin-bottom: 10px;
        }

        .page-content-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
}
.customer-content{
    display: flex;
    flex-direction: row;
    .content-left,.content-right{
        background-color: #fff;
        padding: 16px 16px 18px 16px;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(136, 136, 136, 0.1);
        flex: 1;
    }
    .content-left{
        margin-right: 5px;
    }
   .content-right{
        margin-left: 5px;
   }
}
.mt10{
    margin-top: 10px;
}
</style>
